import { createFileRoute } from "@tanstack/solid-router";
import { onMount } from "solid-js";
import { getUserManager } from "~/lib/auth";

export const Route = createFileRoute("/auth/relay-login")({
  component: RelayLoginPage,
  // Disable SSR for this route — it needs window.location
  ssr: false,
});

function RelayLoginPage() {
  onMount(() => {
    const params = new URLSearchParams(window.location.search);
    const returnHost = params.get("returnHost");
    const prompt = params.get("prompt");
    const kcAction = params.get("kc_action");

    getUserManager().signinRedirect({
      state: { returnHost },
      ...(prompt || kcAction
        ? {
            extraQueryParams: {
              ...(prompt ? { prompt } : {}),
              ...(kcAction ? { kc_action: kcAction } : {}),
            },
          }
        : {}),
    });
  });

  return (
    <div class="min-h-screen flex items-center justify-center p-4">
      <div class="flex flex-col items-center gap-3 text-muted-foreground">
        <div class="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        <p class="text-sm">Redirecting to sign in…</p>
      </div>
    </div>
  );
}
